import React from "react";

export interface ProductMarkProps {
  size?: number;
  className?: string;
  color?: string;
}

/**
 * ivManage Frame mark (iv-19):
 * Square A's strands cut where square B crosses them.
 * Four corner brackets evoking a viewfinder / crate. Brand color: Plum #50404D.
 */
export const IvManageMark: React.FC<ProductMarkProps> = ({
  size = 32,
  className = "",
  color = "#50404D",
}) => {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <g transform="translate(50 50)">
        <path
          d="M-33.10 -33.10 L-18.80 -33.10 L-25.00 -26.90 L-33.10 -26.90 Z M-1.96 -33.10 L33.10 -33.10 L33.10 -26.90 L-8.16 -26.90 Z M33.10 -33.10 L33.10 -18.80 L26.90 -25.00 L26.90 -33.10 Z M33.10 -1.96 L33.10 33.10 L26.90 33.10 L26.90 -8.16 Z M33.10 33.10 L18.80 33.10 L25.00 26.90 L33.10 26.90 Z M1.96 33.10 L-33.10 33.10 L-33.10 26.90 L8.16 26.90 Z M-33.10 33.10 L-33.10 18.80 L-26.90 25.00 L-26.90 33.10 Z M-33.10 1.96 L-33.10 -33.10 L-26.90 -33.10 L-26.90 8.16 Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

/**
 * Zentrak Reticle mark (zt-19):
 * Square B's strands cut where square A crosses them.
 * Four chevrons round a diamond: a sight / waypoint. Accent color: Aubergine Noir #42333E.
 */
export const ZentrakMark: React.FC<ProductMarkProps> = ({
  size = 32,
  className = "",
  color = "#42333E",
}) => {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      className={className}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <g transform="translate(50 50)">
        <path
          d="M0.00 -46.81 L10.11 -36.70 L1.35 -36.70 L-4.38 -42.43 Z M22.02 -24.79 L46.81 0.00 L42.43 4.38 L13.25 -24.79 Z M46.81 0.00 L36.70 10.11 L36.70 1.35 L42.43 -4.38 Z M24.79 22.02 L0.00 46.81 L-4.38 42.43 L24.79 13.25 Z M0.00 46.81 L-10.11 36.70 L-1.35 36.70 L4.38 42.43 Z M-22.02 24.79 L-46.81 0.00 L-42.43 -4.38 L-13.25 24.79 Z M-46.81 0.00 L-36.70 -10.11 L-36.70 -1.35 L-42.43 4.38 Z M-24.79 -22.02 L0.00 -46.81 L4.38 -42.43 L-24.79 -13.25 Z"
          fill={color}
        />
      </g>
    </svg>
  );
};
